// // src/components/Register.jsx
// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   User,
//   Mail,
//   Calendar,
//   Ruler,
//   Weight,
//   Mars,
//   Save,
//   Loader2,
//   X,
//   UserCircle,
// } from "lucide-react";
// import { useUserProfile, useUpdateProfile } from "../../hooks/useAuth";

// const Register = ({ isOpen, onClose }) => {
//   const navigate = useNavigate();
//   const token = localStorage.getItem("authToken");

//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     email: "",
//     dob: "",
//     height: "",
//     weight: "",
//     gender: "",
//   });
//   const [error, setError] = useState("");
//   const [success, setSuccess] = useState("");

//   const { data: profileData, isLoading: fetching } = useUserProfile();
//   const updateProfileMutation = useUpdateProfile();

//   // If no token, close modal
//   useEffect(() => {
//     if (!token && isOpen) {
//       onClose?.();
//     }
//   }, [token, isOpen, onClose]);

//   // Prefill form from existing profile data
//   useEffect(() => {
//     if (profileData && isOpen) {
//       const userData = profileData.user || profileData;

//       // If profile already complete, close modal and go to dashboard
//       if (userData.firstName && userData.lastName) {
//         localStorage.setItem("isProfileCreated", "true");
//         localStorage.setItem("userData", JSON.stringify(userData));
//         window.dispatchEvent(new Event("userUpdated"));
//         onClose?.();
//         navigate("/dashboard");
//         return;
//       }

//       // Prefill any partial data
//       setFormData({
//         firstName: userData.firstName || "",
//         lastName: userData.lastName || "",
//         email: userData.email || "",
//         dob: userData.dob
//           ? new Date(userData.dob).toISOString().split("T")[0]
//           : "",
//         height: userData.height?.toString() || "",
//         weight: userData.weight?.toString() || "",
//         gender: userData.gender || "",
//       });
//     }
//   }, [profileData, isOpen, navigate, onClose]);

//   // Close on Escape key
//   useEffect(() => {
//     const handleEsc = (e) => {
//       if (e.key === "Escape" && isOpen) onClose?.();
//     };
//     document.addEventListener("keydown", handleEsc);
//     return () => document.removeEventListener("keydown", handleEsc);
//   }, [isOpen, onClose]);

//   if (!isOpen) return null;

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prev) => ({ ...prev, [name]: value }));
//     if (error) setError("");
//   };

//   const validateForm = () => {
//     if (!formData.firstName.trim()) return "First name is required";
//     if (!formData.lastName.trim()) return "Last name is required";
//     if (!formData.email.trim()) return "Email is required";
//     if (!/^\S+@\S+\.\S+$/.test(formData.email))
//       return "Please enter a valid email address";
//     if (!formData.dob) return "Date of birth is required";
//     if (!formData.height) return "Height is required";
//     if (formData.height < 50 || formData.height > 300)
//       return "Height must be between 50 cm and 300 cm";
//     if (!formData.weight) return "Weight is required";
//     if (formData.weight < 10 || formData.weight > 500)
//       return "Weight must be between 10 kg and 500 kg";
//     if (!formData.gender) return "Gender is required";
//     return null;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     const validationError = validateForm();
//     if (validationError) {
//       setError(validationError);
//       return;
//     }

//     setError("");
//     setSuccess("");

//     try {
//       const result = await updateProfileMutation.mutateAsync({
//         firstName: formData.firstName.trim(),
//         lastName: formData.lastName.trim(),
//         email: formData.email.trim(),
//         dob: formData.dob,
//         height: Number(formData.height),
//         weight: Number(formData.weight),
//         gender: formData.gender,
//       });

//       const savedUser = result.user || {
//         ...formData,
//         height: Number(formData.height),
//         weight: Number(formData.weight),
//       };

//       localStorage.setItem("isProfileCreated", "true");
//       localStorage.setItem("userData", JSON.stringify(savedUser));
//       window.dispatchEvent(new Event("userUpdated"));

//       setSuccess("Profile saved successfully!");
//       setTimeout(() => {
//         onClose?.();
//         navigate("/dashboard");
//       }, 1200);
//     } catch (err) {
//       setError(err.response?.data?.message || "Network error. Please try again.");
//     }
//   };

//   const inputClass =
//     "w-full bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-600 focus:outline-none focus:border-[#BBE520]/60 focus:ring-1 focus:ring-[#BBE520]/30 transition-all text-sm py-2.5 px-4";
//   const iconInputClass =
//     "w-full bg-white/5 border border-white/10 rounded-xl text-white placeholder-gray-600 focus:outline-none focus:border-[#BBE520]/60 focus:ring-1 focus:ring-[#BBE520]/30 transition-all text-sm py-2.5 pl-10 pr-4";
//   const labelClass =
//     "block text-xs font-medium text-gray-400 mb-1.5 uppercase tracking-wider";
//   const iconClass =
//     "absolute left-3 top-1/2 -translate-y-1/2 text-[#BBE520]/60";

//   return (
//     <div
//       className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6"
//       onClick={(e) => e.target === e.currentTarget && onClose?.()}
//     >
//       {/* Backdrop */}
//       <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />

//       {/* Modal */}
//       <div className="relative w-full max-w-lg bg-[#0f1a00] rounded-3xl shadow-2xl overflow-hidden border border-[#BBE520]/20 max-h-[90vh] flex flex-col">
//         {/* Top accent bar */}
//         <div className="h-1 w-full bg-[#BBE520] flex-shrink-0" />

//         {/* Close button */}
//         <button
//           onClick={onClose}
//           className="absolute top-4 right-4 text-gray-400 hover:text-[#BBE520] transition-colors z-10"
//         >
//           <X size={20} />
//         </button>

//         {/* Scrollable body */}
//         <div className="overflow-y-auto flex-1 px-8 py-6">
//           {/* Header */}
//           <div className="flex flex-col items-center mb-6">
//             <div className="w-14 h-14 rounded-2xl bg-[#BBE520]/10 border border-[#BBE520]/30 flex items-center justify-center mb-3">
//               <UserCircle size={26} className="text-[#BBE520]" />
//             </div>
//             <h2 className="text-xl font-bold text-white tracking-tight">
//               Complete Your Profile
//             </h2>
//             <p className="text-xs text-gray-400 mt-1 text-center">
//               Fill in your details to personalize your experience
//             </p>
//           </div>

//           {/* Alerts */}
//           {success && (
//             <div className="mb-4 px-4 py-2.5 bg-green-900/30 border border-green-500/30 rounded-xl">
//               <p className="text-green-400 text-xs text-center font-medium">{success}</p>
//             </div>
//           )}
//           {error && (
//             <div className="mb-4 px-4 py-2.5 bg-red-900/30 border border-red-500/30 rounded-xl">
//               <p className="text-red-400 text-xs text-center">{error}</p>
//             </div>
//           )}

//           {fetching ? (
//             <div className="flex flex-col items-center py-10">
//               <Loader2 className="animate-spin text-[#BBE520]" size={36} />
//               <p className="text-gray-400 text-sm mt-3">Loading your profile...</p>
//             </div>
//           ) : (
//             <form onSubmit={handleSubmit} className="space-y-4">
//               {/* Name row */}
//               <div className="grid grid-cols-2 gap-3">
//                 <div>
//                   <label className={labelClass}>First Name *</label>
//                   <div className="relative">
//                     <User size={15} className={iconClass} />
//                     <input
//                       type="text"
//                       name="firstName"
//                       value={formData.firstName}
//                       onChange={handleChange}
//                       placeholder="First name"
//                       className={iconInputClass}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className={labelClass}>Last Name *</label>
//                   <input
//                     type="text"
//                     name="lastName"
//                     value={formData.lastName}
//                     onChange={handleChange}
//                     placeholder="Last name"
//                     className={inputClass}
//                   />
//                 </div>
//               </div>

//               {/* Email */}
//               <div>
//                 <label className={labelClass}>Email Address *</label>
//                 <div className="relative">
//                   <Mail size={15} className={iconClass} />
//                   <input
//                     type="email"
//                     name="email"
//                     value={formData.email}
//                     onChange={handleChange}
//                     placeholder="you@example.com"
//                     className={iconInputClass}
//                   />
//                 </div>
//               </div>

//               {/* DOB + Gender */}
//               <div className="grid grid-cols-2 gap-3">
//                 <div>
//                   <label className={labelClass}>Date of Birth *</label>
//                   <div className="relative">
//                     <Calendar size={15} className={iconClass} />
//                     <input
//                       type="date"
//                       name="dob"
//                       value={formData.dob}
//                       onChange={handleChange}
//                       className={`${iconInputClass} [color-scheme:dark]`}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className={labelClass}>Gender *</label>
//                   <div className="relative">
//                     <Mars size={15} className={iconClass} />
//                     <select
//                       name="gender"
//                       value={formData.gender}
//                       onChange={handleChange}
//                       className={`${iconInputClass} appearance-none bg-[#0f1a00] cursor-pointer`}
//                     >
//                       <option value="">Select</option>
//                       <option value="Male">Male</option>
//                       <option value="Female">Female</option>
//                       <option value="Other">Other</option>
//                     </select>
//                   </div>
//                 </div>
//               </div>

//               {/* Height + Weight */}
//               <div className="grid grid-cols-2 gap-3">
//                 <div>
//                   <label className={labelClass}>Height (cm) *</label>
//                   <div className="relative">
//                     <Ruler size={15} className={iconClass} />
//                     <input
//                       type="number"
//                       name="height"
//                       value={formData.height}
//                       onChange={handleChange}
//                       placeholder="e.g. 170"
//                       className={iconInputClass}
//                     />
//                   </div>
//                 </div>
//                 <div>
//                   <label className={labelClass}>Weight (kg) *</label>
//                   <div className="relative">
//                     <Weight size={15} className={iconClass} />
//                     <input
//                       type="number"
//                       name="weight"
//                       value={formData.weight}
//                       onChange={handleChange}
//                       placeholder="e.g. 65"
//                       className={iconInputClass}
//                     />
//                   </div>
//                 </div>
//               </div>

//               {/* Submit */}
//               <button
//                 type="submit"
//                 disabled={updateProfileMutation.isPending}
//                 className="w-full mt-2 bg-[#BBE520] text-[#0f1a00] py-3 rounded-xl font-bold text-sm hover:bg-[#cef72a] active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 tracking-wide"
//               >
//                 {updateProfileMutation.isPending ? (
//                   <>
//                     <Loader2 className="animate-spin" size={16} /> Saving...
//                   </>
//                 ) : (
//                   <>
//                     <Save size={16} /> Save Profile
//                   </>
//                 )}
//               </button>
//             </form>
//           )}

//           <p className="text-center text-[10px] text-gray-600 mt-5">
//             All information is secure and used only to improve your experience
//           </p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Register;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  User,
  Mail,
  Calendar,
  Ruler,
  Weight,
  Mars,
  Save,
  Loader2,
  X,
  UserCircle,
} from "lucide-react";
import { useUserProfile, useUpdateProfile } from "../../hooks/useAuth";

const Register = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    dob: "",
    height: "",
    weight: "",
    gender: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const { data: profileData, isLoading: fetching } = useUserProfile();
  const updateProfileMutation = useUpdateProfile();

  // If no token, close modal
  useEffect(() => {
    if (!token && isOpen) {
      onClose?.();
    }
  }, [token, isOpen, onClose]);

  // Prefill form from existing profile data
  useEffect(() => {
    if (profileData && isOpen) {
      const userData = profileData.user || profileData;

      // If profile already complete, close modal and go to dashboard
      if (userData.firstName && userData.lastName) {
        localStorage.setItem("isProfileCreated", "true");
        localStorage.setItem("userData", JSON.stringify(userData));
        window.dispatchEvent(new Event("userUpdated"));
        onClose?.();
        navigate("/dashboard");
        return;
      }

      // Prefill any partial data
      setFormData({
        firstName: userData.firstName || "",
        lastName: userData.lastName || "",
        email: userData.email || "",
        dob: userData.dob
          ? new Date(userData.dob).toISOString().split("T")[0]
          : "",
        height: userData.height?.toString() || "",
        weight: userData.weight?.toString() || "",
        gender: userData.gender || "",
      });
    }
  }, [profileData, isOpen, navigate, onClose]);

  // Close on Escape key
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape" && isOpen) onClose?.();
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (error) setError("");
  };

  const validateForm = () => {
    if (!formData.firstName.trim()) return "First name is required";
    if (!formData.lastName.trim()) return "Last name is required";
    if (!formData.email.trim()) return "Email is required";
    if (!/^\S+@\S+\.\S+$/.test(formData.email))
      return "Please enter a valid email address";
    if (!formData.dob) return "Date of birth is required";
    if (!formData.height) return "Height is required";
    if (formData.height < 50 || formData.height > 300)
      return "Height must be between 50 cm and 300 cm";
    if (!formData.weight) return "Weight is required";
    if (formData.weight < 10 || formData.weight > 500)
      return "Weight must be between 10 kg and 500 kg";
    if (!formData.gender) return "Gender is required";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationError = validateForm();
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setSuccess("");

    try {
      const result = await updateProfileMutation.mutateAsync({
        firstName: formData.firstName.trim(),
        lastName: formData.lastName.trim(),
        email: formData.email.trim(),
        dob: formData.dob,
        height: Number(formData.height),
        weight: Number(formData.weight),
        gender: formData.gender,
      });

      const savedUser = result.user || {
        ...formData,
        height: Number(formData.height),
        weight: Number(formData.weight),
      };

      localStorage.setItem("isProfileCreated", "true");
      localStorage.setItem("userData", JSON.stringify(savedUser));
      window.dispatchEvent(new Event("userUpdated"));

      setSuccess("Profile saved successfully!");
      setTimeout(() => {
        onClose?.();
        navigate("/dashboard");
      }, 1200);
    } catch (err) {
      setError(err.response?.data?.message || "Network error. Please try again.");
    }
  };

  // Light theme classes
  const inputClass =
    "w-full bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#BBE520] focus:ring-2 focus:ring-[#BBE520]/20 transition-all text-sm py-2.5 px-4";
  const iconInputClass =
    "w-full bg-gray-50 border border-gray-200 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:border-[#BBE520] focus:ring-2 focus:ring-[#BBE520]/20 transition-all text-sm py-2.5 pl-10 pr-4";
  const labelClass =
    "block text-xs font-medium text-gray-500 mb-1.5 uppercase tracking-wider";
  const iconClass =
    "absolute left-3 top-1/2 -translate-y-1/2 text-[#7a9c14]";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center px-4 py-6"
      onClick={(e) => e.target === e.currentTarget && onClose?.()}
    >
      {/* Backdrop - lighter */}
      <div className="absolute inset-0 bg-black/30 backdrop-blur-sm" />

      {/* Modal - Light theme, no border */}
      <div className="relative w-full max-w-lg bg-white rounded-3xl shadow-2xl overflow-hidden max-h-[90vh] flex flex-col">

        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors z-10"
        >
          <X size={20} />
        </button>

        {/* Scrollable body */}
        <div className="overflow-y-auto flex-1 px-8 py-6">
          {/* Header */}
          <div className="flex flex-col items-center mb-6">
            <div className="w-14 h-14 rounded-2xl bg-[#BBE520]/10 flex items-center justify-center mb-3">
              <UserCircle size={26} className="text-[#7a9c14]" />
            </div>
            <h2 className="text-xl font-bold text-gray-900 tracking-tight">
              Complete Your Profile
            </h2>
            <p className="text-xs text-gray-500 mt-1 text-center">
              Fill in your details to personalize your experience
            </p>
          </div>

          {/* Alerts - Light theme */}
          {success && (
            <div className="mb-4 px-4 py-2.5 bg-green-50 border border-green-200 rounded-xl">
              <p className="text-green-700 text-xs text-center font-medium">{success}</p>
            </div>
          )}
          {error && (
            <div className="mb-4 px-4 py-2.5 bg-red-50 border border-red-200 rounded-xl">
              <p className="text-red-600 text-xs text-center">{error}</p>
            </div>
          )}

          {fetching ? (
            <div className="flex flex-col items-center py-10">
              <Loader2 className="animate-spin text-[#7a9c14]" size={36} />
              <p className="text-gray-500 text-sm mt-3">Loading your profile...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {/* Name row */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelClass}>First Name *</label>
                  <div className="relative">
                    <User size={15} className={iconClass} />
                    <input
                      type="text"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      placeholder="First name"
                      className={iconInputClass}
                    />
                  </div>
                </div>
                <div>
                  <label className={labelClass}>Last Name *</label>
                  <input
                    type="text"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    placeholder="Last name"
                    className={inputClass}
                  />
                </div>
              </div>

              {/* Email */}
              <div>
                <label className={labelClass}>Email Address *</label>
                <div className="relative">
                  <Mail size={15} className={iconClass} />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="you@example.com"
                    className={iconInputClass}
                  />
                </div>
              </div>

              {/* DOB + Gender */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelClass}>Date of Birth *</label>
                  <div className="relative">
                    <Calendar size={15} className={iconClass} />
                    <input
                      type="date"
                      name="dob"
                      value={formData.dob}
                      onChange={handleChange}
                      className={`${iconInputClass} [color-scheme:light]`}
                    />
                  </div>
                </div>
                <div>
                  <label className={labelClass}>Gender *</label>
                  <div className="relative">
                    <Mars size={15} className={iconClass} />
                    <select
                      name="gender"
                      value={formData.gender}
                      onChange={handleChange}
                      className={`${iconInputClass} appearance-none bg-white cursor-pointer`}
                    >
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Height + Weight */}
              <div className="grid grid-cols-2 gap-3">
                <div>
                  <label className={labelClass}>Height (cm) *</label>
                  <div className="relative">
                    <Ruler size={15} className={iconClass} />
                    <input
                      type="number"
                      name="height"
                      value={formData.height}
                      onChange={handleChange}
                      placeholder="e.g. 170"
                      className={iconInputClass}
                    />
                  </div>
                </div>
                <div>
                  <label className={labelClass}>Weight (kg) *</label>
                  <div className="relative">
                    <Weight size={15} className={iconClass} />
                    <input
                      type="number"
                      name="weight"
                      value={formData.weight}
                      onChange={handleChange}
                      placeholder="e.g. 65"
                      className={iconInputClass}
                    />
                  </div>
                </div>
              </div>

              {/* Submit */}
              <button
                type="submit"
                disabled={updateProfileMutation.isPending}
                className="w-full mt-2 bg-[#BBE520] text-gray-900 py-3 rounded-xl font-bold text-sm hover:bg-[#cef72a] active:scale-95 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2 tracking-wide"
              >
                {updateProfileMutation.isPending ? (
                  <>
                    <Loader2 className="animate-spin" size={16} /> Saving...
                  </>
                ) : (
                  <>
                    <Save size={16} /> Save Profile
                  </>
                )}
              </button>
            </form>
          )}

          <p className="text-center text-[10px] text-gray-400 mt-5">
            All information is secure and used only to improve your experience
          </p>
        </div>
      </div>
    </div>
  );
};

export default Register;